/**
 * 对接孔明系统事件，触发广告系统对应任务，
 * 文档地址：https://hellobike.yuque.com/platform_app/uqc2ek/uukkct?singleDoc
 * 相关需求：http://wiki.cheyaoshicorp.com/pages/viewpage.action?pageId=330709267
 */
import { callNative } from '@/shared/utils/bridge';

/**
 * 订阅 TCP 活动弹窗普通事件
 * pageId：页面唯一id，必填项。
 * busInfo：一些业务参数。选填。
 * callback: 回调函数，订阅成功则回调成功；订阅失败则回回调失败
 * 调用时机：进入页面的时候 调用
 */
export const subscribeTCP = (
  pageId: string,
): Promise<{
    code: number, // 0 成功 -1 订阅失败
    msg: string, //
    pageId: string;
}> => callNative({
  classMap: 'business/marketing',
  method: 'subscribeTCP',
  params: {
    pageId,
  },
});


/**
 * 查询事件方法
 * pageId：页面唯一id，必填项。
 * busInfo：一些业务参数。选填。
 * callback: 回调函数，当收到事件，同时加载成功之后会回调失败；如果收到事件，但是加载失败，会回调失败；如果收不到事件，则不会回调
 * 调用时机：1s 轮询一次
 */
export const queryEvent = (
  pageId: string,
): Promise<{
    code: number, // 0 成功 -1 订阅失败
    msg: string, //
    pageId: string;
    advertId?: string;// 成功时 返回广告位 id
}> => callNative({
  classMap: 'business/marketing',
  method: 'queryEvent',
  params: {
    pageId,
  },
});


/**
 * 取消订阅 TCP 活动弹窗事件。
 * pageId：页面唯一id，必填项。
 * 离开页面时调用
 */
export const unsubscribeTCP = (
  pageId: string,
): Promise<{
  code: number, // 0 成功 -1 订阅失败
  msg: string, //
}> => callNative({
  classMap: 'business/marketing',
  method: 'unsubscribeTCP',
  params: {
    pageId,
  },
});


/**
 * 显示客户端广告位组件事件
 * pageId：页面唯一id，必填项。
 * callback: 回调函数，弹窗弹出失败，会回调失败；弹窗弹出成功，同时在弹窗关闭的时候会回调成功。
 */
export const showAdvert = (
  pageId: string,
  advertId: string,
): Promise<{
  code: number, // 0 成功 -1 订阅失败
  msg: string, //
  pageId: string;
  advertId?: string;// 成功时 返回广告位 id
  eventType?: string;
  hasRoute?: boolean;
  hasRequestSuccess?: boolean;
}> => callNative({
  classMap: 'business/marketing',
  method: 'showAdvert',
  params: {
    pageId,
    advertId,
  },
});
